/**
 * A tiny event for "the server no longer accepts this session".
 *
 * The Apollo `ErrorLink` lives outside React and cannot call `signOut`, and
 * `SessionProvider` lives inside it and must not import Apollo. This is the
 * seam between them: the link notifies, the provider subscribes.
 */

type Listener = () => void;
const listeners = new Set<Listener>();

export function notifySessionExpired(): void {
    for (const listener of new Set(listeners)) {
        listener();
    }
}

/** Subscribe to session-expired notices. Returns an unsubscribe function. */
export function onSessionExpired(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
